import type { SupabaseClient } from "@supabase/supabase-js";

export async function fetchBcSegmentId(
  supabase: SupabaseClient,
  segmentNumber: string,
): Promise<number | null> {
  const { data, error } = await supabase
    .from("bc_segments")
    .select("id")
    .eq("number", segmentNumber)
    .maybeSingle();
  if (error) throw error;
  return typeof data?.id === "number" ? data.id : null;
}

export async function fetchCompanyIdsByBcSegment(
  supabase: SupabaseClient,
  segmentNumber: string,
): Promise<number[]> {
  const ids = new Set<number>();
  const bcSegmentId = await fetchBcSegmentId(supabase, segmentNumber);

  if (bcSegmentId != null) {
    const { data: memberships, error: membershipError } = await supabase
      .from("company_segments")
      .select("company_id")
      .eq("bc_segment_id", bcSegmentId);
    if (membershipError) throw membershipError;
    for (const row of memberships ?? []) {
      if (typeof row.company_id === "number") ids.add(row.company_id);
    }
  }

  const { data: legacyCompanies, error: legacyError } = await supabase
    .from("companies")
    .select("id")
    .eq("sector", segmentNumber)
    .is("bc_archived_at", null);
  if (legacyError) throw legacyError;
  for (const row of legacyCompanies ?? []) {
    if (typeof row.id === "number") ids.add(row.id);
  }

  return [...ids];
}

export async function fetchContactIdsByBcSegment(
  supabase: SupabaseClient,
  segmentNumber: string,
): Promise<number[]> {
  const bcSegmentId = await fetchBcSegmentId(supabase, segmentNumber);
  if (bcSegmentId == null) return [];

  const { data: memberships, error } = await supabase
    .from("contact_segments")
    .select("contact_id")
    .eq("bc_segment_id", bcSegmentId);
  if (error) throw error;

  return [
    ...new Set(
      (memberships ?? [])
        .map((row) => row.contact_id)
        .filter((id): id is number => typeof id === "number"),
    ),
  ];
}
